import { Component } from '@angular/core';

@Component({
  selector: 'bst-frontend-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  title = 'bst';
}
